import { render } from "./MovieListButtons.vue?vue&type=template&id=0067186f&scoped=true"
import script from "./MovieListButtons.vue?vue&type=script&lang=js"
export * from "./MovieListButtons.vue?vue&type=script&lang=js"

import "./MovieListButtons.vue?vue&type=style&index=0&id=0067186f&lang=scss&scoped=true"
import "./MovieListButtons.vue?vue&type=style&index=1&id=0067186f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0067186f"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QRating from 'quasar/src/components/rating/QRating.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QTooltip,QBadge,QMenu,QRating,QAvatar});
